<template>
  <h1>Go Away</h1>
</template>
